export enum FeedbackPerfil {
  SICREDIX = "perfil-app",
  FAIXA_IDADE = "idade-residentes",
}
